/* =====================================================================
   Is That Matty? — shared behaviour for matty-* sections
   Loaded by each section with `defer`; guarded so it only runs once.
   Re-initialises a section when it's re-rendered in the theme editor.
   ===================================================================== */
(function () {
  if (window.Matty) return;
  var Matty = (window.Matty = {});

  function $all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function once(el, key) {
    if (el.dataset['matty' + key]) return false;
    el.dataset['matty' + key] = '1';
    return true;
  }

  /* ---------------- Add to cart (CartHelper first, like Olive Rose) ---------------- */
  Matty.addToCart = function (e, variantId, button) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    if (window.CartHelper && typeof CartHelper.addToCart === 'function') {
      return CartHelper.addToCart(e, variantId, 1, currency, {}, true);
    }
    if (button) button.classList.add('is-loading');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function () { window.location.href = '/cart'; })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  };

  /* ---------------- Drawer (one shared element, content from <template>) ---------------- */
  var drawer, drawerTitle, drawerBody, lastTrigger;
  function ensureDrawer() {
    if (drawer) return;
    drawer = document.createElement('div');
    drawer.className = 'matty-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-labelledby', 'matty-drawer-title');
    drawer.innerHTML =
      '<div class="matty-drawer__panel">' +
      '<button type="button" class="matty-drawer__close" aria-label="Close">' +
      '<svg width="23" height="23" viewBox="0 0 23 23" fill="none" aria-hidden="true"><path d="M2.76 2.76L20.32 20.32M20.32 2.76L2.76 20.32" stroke="black" stroke-width="2" stroke-linecap="round"/></svg>' +
      '</button><h2 class="matty-drawer__title" id="matty-drawer-title"></h2>' +
      '<div class="matty-drawer__rule"></div><div class="matty-drawer__body"></div></div>';
    document.body.appendChild(drawer);
    drawerTitle = drawer.querySelector('.matty-drawer__title');
    drawerBody = drawer.querySelector('.matty-drawer__body');
    drawer.querySelector('.matty-drawer__close').addEventListener('click', Matty.closeDrawer);
    drawer.addEventListener('click', function (e) { if (e.target === drawer) Matty.closeDrawer(); });
    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') Matty.closeDrawer();
      if (e.key === 'Tab') { // keep focus inside
        var f = $all(drawer, 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }
  Matty.openDrawer = function (templateId, trigger) {
    var tpl = document.getElementById(templateId);
    if (!tpl) return;
    ensureDrawer();
    drawerTitle.textContent = tpl.dataset.title || '';
    var tmp = document.createElement('div');
    tmp.appendChild(tpl.content.cloneNode(true));
    var decoder = document.createElement('textarea');
    decoder.innerHTML = tmp.innerHTML;
    drawerBody.innerHTML = decoder.value;
    lastTrigger = trigger || null;
    drawer.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    drawer.querySelector('.matty-drawer__close').focus();
  };
  Matty.closeDrawer = function () {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastTrigger) lastTrigger.focus();
  };
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-matty-drawer]');
    if (!t) return;
    e.preventDefault();
    Matty.openDrawer(t.getAttribute('data-matty-drawer'), t);
  });

  /* Card add-to-cart buttons (delegated, works for every product row) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-matty-add]');
    if (!b || b.getAttribute('aria-disabled') === 'true') return;
    Matty.addToCart(e, Number(b.getAttribute('data-matty-add')), b);
  });

  /* ---------------- Gallery ---------------- */
  function initGallery(root) {
    $all(root, '[data-matty-gallery]').forEach(function (g) {
      if (!once(g, 'Gallery')) return;
      var track = g.querySelector('[data-track]');
      var thumbs = $all(g, '[data-thumb-index]');
      var dots = $all(g, '[data-dot-index]');
      if (!track) return;
      function setActive(i) {
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      }
      function goTo(i) { track.scrollTo({ left: track.clientWidth * i }); setActive(i); }
      g.mattyGoTo = goTo;
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(Number(t.dataset.thumbIndex)); }); });
      dots.forEach(function (d) { d.addEventListener('click', function () { goTo(Number(d.dataset.dotIndex)); }); });
      var timer;
      track.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); }, 80);
      }, { passive: true });
    });
  }

  /* ---------------- Product form + variant picker ---------------- */
  function initProduct(root) {
    $all(root, '[data-matty-product]').forEach(function (p) {
      if (!once(p, 'Product')) return;
      var variants = [];
      var json = p.querySelector('script[data-matty-variants]');
      try { variants = JSON.parse(json.textContent); } catch (e) {}
      var input = p.querySelector('[data-matty-variant-input]');
      var atc = p.querySelector('[data-matty-atc]');
      var gallery = p.querySelector('[data-matty-gallery]');

      function render(v) {
        if (!atc || !v) return;
        var text = atc.querySelector('[data-atc-text]');
        if (v.available) {
          text.textContent = atc.dataset.label + (atc.dataset.showPrice === 'true' ? ' – ' + v.price : '');
          atc.removeAttribute('aria-disabled');
        } else {
          text.textContent = atc.dataset.soldOut;
          atc.setAttribute('aria-disabled', 'true');
        }
      }

      $all(p, '[data-variant-id]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = Number(btn.dataset.variantId);
          var v = variants.find(function (x) { return x.id === id; });
          if (!v) return;
          $all(p, '[data-variant-id]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          if (input) input.value = id;
          render(v);
          if (v.mediaId && gallery && gallery.mattyGoTo) {
            var slides = $all(gallery, '.matty-slide');
            var idx = slides.findIndex(function (s) { return Number(s.dataset.mediaId) === v.mediaId; });
            if (idx > -1) gallery.mattyGoTo(idx);
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          window.history.replaceState({}, '', url.toString());
        });
      });

      var form = p.querySelector('form[data-matty-form]');
      if (form) {
        // Capture phase so theme product handlers never see this form (same as Olive Rose)
        document.addEventListener('submit', function (e) {
          if (e.target !== form) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          if (atc && atc.getAttribute('aria-disabled') === 'true') return;
          var id = Number(input && input.value);
          if (id) Matty.addToCart(e, id, atc);
        }, true);
      }
    });
  }

  /* ---------------- Tabs ---------------- */
  function initTabs(root) {
    $all(root, '[data-matty-tabs]').forEach(function (list) {
      if (!once(list, 'Tabs')) return;
      var tabs = $all(list, '[role="tab"]');
      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
          select(next); next.focus();
        });
      });
    });
  }

  /* ---------------- Judge.me restyle (ported from Olive Rose) ---------------- */
  var STAR = '<svg width="13" height="12" viewBox="0 0 13 12" aria-hidden="true"><path d="M6.5 0l1.53 4.38H12.7L8.94 7.1l1.43 4.4L6.5 8.8l-3.87 2.7 1.43-4.4L.3 4.38h4.67z" fill="currentColor"/></svg>';
  function initReviews(root) {
    $all(root, '[data-matty-reviews]').forEach(function (box) {
      if (!once(box, 'Reviews')) return;
      var label = box.dataset.writeLabel;
      function restyle() {
        $all(box, '.jdgm-histogram__row[data-rating]').forEach(function (row) {
          var star = row.querySelector('.jdgm-histogram__star');
          if (star && !star.dataset.mattyDone) {
            var s = document.createElement('span');
            s.textContent = row.getAttribute('data-rating') + ' stars ';
            star.prepend(s);
            star.dataset.mattyDone = '1';
          }
        });
        $all(box, '.jdgm-histogram__frequency').forEach(function (el) {
          var t = el.textContent.replace(/[()]/g, '').trim();
          if (t !== el.textContent) el.textContent = t;
        });
        $all(box, '.jdgm-rev__rating').forEach(function (el) {
          if (el.dataset.mattyDone) return;
          var n = Math.round(Number(el.getAttribute('data-score')) || 5);
          var html = '';
          for (var i = 1; i <= 5; i++) html += '<span style="' + (i > n ? 'color:#C4C4C4' : '') + '">' + STAR + '</span>';
          el.innerHTML = '<span style="display:inline-flex;gap:2px">' + html + '</span>';
          el.dataset.mattyDone = '1';
        });
        var link = box.querySelector('.jdgm-write-rev-link');
        if (link && label && link.textContent !== label) link.textContent = label;
      }
      restyle();
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; restyle(); });
      }).observe(box, { childList: true, subtree: true });
    });
  }

  Matty.init = function (root) {
    root = root || document;
    initGallery(root);
    initProduct(root);
    initTabs(root);
    initReviews(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { Matty.init(document); });
  } else {
    Matty.init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { Matty.init(e.target); });
})();
